(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name payments.controller:PaymentsRecallModalCtrl
   *
   * @description
   *
   */
  angular
    .module('payments')
    .controller('PaymentsRecallModalCtrl', PaymentsRecallModalCtrl);

  function PaymentsRecallModalCtrl($rootScope, $uibModalInstance, data) {
    var vm = this;

    vm.init = function(){
      vm.payment = angular.copy(data);
      vm.formSubmitted = false;
      vm.recallReasonsList = [{key: 'paymentsReturn.reasonTech', value: "TECH"},{key: 'paymentsReturn.reasonFrad', value: "FRAD"}, {key: 'paymentsReturn.reasonDupl', value: "DUPL"}];
      vm.recallReasonObject = {
        reasonCode: "TECH",
        additionalnfo: ""
      };
    };

    vm.confirm = function () {
      vm.formSubmitted = true;
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl') vm.recallReasonObject = {};
      if ($rootScope.APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl' && !vm.recallForm.$valid) return;
      $uibModalInstance.close(vm.recallReasonObject);
    };

    vm.init();
  }
}());
